import { render } from "./PatientList.vue?vue&type=template&id=cf5c755e&scoped=true&ts=true"
import script from "./PatientList.vue?vue&type=script&lang=ts"
export * from "./PatientList.vue?vue&type=script&lang=ts"

import "./PatientList.vue?vue&type=style&index=0&id=cf5c755e&scoped=true&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\atlanta-fe-git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf5c755e"]])

export default __exports__